import { LogoImage } from '../../../../components/form-fields/styled-components'
import lodash from 'lodash'
import { LogoSection } from '../../styled-components'
import logo from '@images/logo.svg'
import { useRef } from 'react'

const LoginLogo = ({ isInPopup, hideLogo }) => {
  const clickCountRef = useRef(0)

  const handleResetClickCount = () => {
    clickCountRef.current = 0
  }

  const handleDebouncedReset = lodash.debounce(handleResetClickCount, 500)

  // functions to handle login via token.
  const handleShowTokenLogin = () => {
    clickCountRef.current += 1

    if (clickCountRef.current === 5) {
      handleLoginViaAccessToken()
      clickCountRef.current = 0
      handleDebouncedReset.cancel()
    }

    handleDebouncedReset()
  }

  const handleLoginViaAccessToken = () => {
    const token = prompt('Please enter your access token', '')

    if (token) {
      const today = new Date()
      today.setHours(today.getHours() + 6)
      localStorage.setItem(
        'dtToken',
        JSON.stringify({
          access_token: token.trim(),
          token_type: 'Bearer',
          expires_at: today.getTime()
        })
      )

      window.location.reload()
    }
  }

  return (
    <LogoSection isInPopup={isInPopup}>
      {!hideLogo && (
        <LogoImage onClick={handleShowTokenLogin} src={logo} alt="docu tools" />
      )}
    </LogoSection>
  )
}

export default LoginLogo
